var _ = require('lodash');
var angular = require('angular/index');
require('../core');

angular.module('utility-ng-interface').run(function (Interface, $injector) {
  Interface.type('builder', {
    defaultValue: function () {
      return {};
    },
    convertToSource: function convertBackToCollection(syncProp, req) {
      var fn = this[this.activeMethod];
      return fn.call(this, req.typeDef, syncProp);
    },
    afterConvertToSync: function (sourceProp, dtdReq) {
      var Builder = $injector.get(dtdReq.typeDef);

      return new Builder(sourceProp);
    },
    isOfType: function verifyTypeFactory(val) {
      return !_.isNull(val) && !_.isUndefined(val) && _.isObject(val);
    }
  });

  Interface.type('ngDefinition', Interface.type('builder'));
});



// WEBPACK FOOTER //
// ./app/vendor/utility-ng-interface/src/types/builder.js